var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';
import { TextField, Button, Typography, Box, InputAdornment, CircularProgress, Select, MenuItem, FormControl, InputLabel, Grid, ListItemText, FormControlLabel, Checkbox, Link } from '@mui/material';
import { Phone, Sms } from '@mui/icons-material';
import { useNotification } from '../context/NotificationContext';
// Country data with codes, names and flags
const countries = [
    { id: 'AF', code: '+93', name: 'Afghanistan', flag: '🇦🇫' },
    { id: 'AL', code: '+355', name: 'Albania', flag: '🇦🇱' },
    { id: 'DZ', code: '+213', name: 'Algeria', flag: '🇩🇿' },
    { id: 'AD', code: '+376', name: 'Andorra', flag: '🇦🇩' },
    { id: 'AO', code: '+244', name: 'Angola', flag: '🇦🇴' },
    { id: 'AG', code: '+1', name: 'Antigua and Barbuda', flag: '🇦🇬' },
    { id: 'AR', code: '+54', name: 'Argentina', flag: '🇦🇷' },
    { id: 'AM', code: '+374', name: 'Armenia', flag: '🇦🇲' },
    { id: 'AU', code: '+61', name: 'Australia', flag: '🇦🇺' },
    { id: 'AT', code: '+43', name: 'Austria', flag: '🇦🇹' },
    { id: 'AZ', code: '+994', name: 'Azerbaijan', flag: '🇦🇿' },
    { id: 'BS', code: '+1', name: 'Bahamas', flag: '🇧🇸' },
    { id: 'BH', code: '+973', name: 'Bahrain', flag: '🇧🇭' },
    { id: 'BD', code: '+880', name: 'Bangladesh', flag: '🇧🇩' },
    { id: 'BB', code: '+1', name: 'Barbados', flag: '🇧🇧' },
    { id: 'BY', code: '+375', name: 'Belarus', flag: '🇧🇾' },
    { id: 'BE', code: '+32', name: 'Belgium', flag: '🇧🇪' },
    { id: 'BZ', code: '+501', name: 'Belize', flag: '🇧🇿' },
    { id: 'BJ', code: '+229', name: 'Benin', flag: '🇧🇯' },
    { id: 'BT', code: '+975', name: 'Bhutan', flag: '🇧🇹' },
    { id: 'BO', code: '+591', name: 'Bolivia', flag: '🇧🇴' },
    { id: 'BA', code: '+387', name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
    { id: 'BW', code: '+267', name: 'Botswana', flag: '🇧🇼' },
    { id: 'BR', code: '+55', name: 'Brazil', flag: '🇧🇷' },
    { id: 'BN', code: '+673', name: 'Brunei', flag: '🇧🇳' },
    { id: 'BG', code: '+359', name: 'Bulgaria', flag: '🇧🇬' },
    { id: 'BF', code: '+226', name: 'Burkina Faso', flag: '🇧🇫' },
    { id: 'BI', code: '+257', name: 'Burundi', flag: '🇧🇮' },
    { id: 'KH', code: '+855', name: 'Cambodia', flag: '🇰🇭' },
    { id: 'CM', code: '+237', name: 'Cameroon', flag: '🇨🇲' },
    { id: 'CA', code: '+1', name: 'Canada', flag: '🇨🇦' },
    { id: 'CV', code: '+238', name: 'Cape Verde', flag: '🇨🇻' },
    { id: 'CF', code: '+236', name: 'Central African Republic', flag: '🇨🇫' },
    { id: 'TD', code: '+235', name: 'Chad', flag: '🇹🇩' },
    { id: 'CL', code: '+56', name: 'Chile', flag: '🇨🇱' },
    { id: 'CN', code: '+86', name: 'China', flag: '🇨🇳' },
    { id: 'CO', code: '+57', name: 'Colombia', flag: '🇨🇴' },
    { id: 'KM', code: '+269', name: 'Comoros', flag: '🇰🇲' },
    { id: 'CG', code: '+242', name: 'Congo', flag: '🇨🇬' },
    { id: 'CR', code: '+506', name: 'Costa Rica', flag: '🇨🇷' },
    { id: 'HR', code: '+385', name: 'Croatia', flag: '🇭🇷' },
    { id: 'CU', code: '+53', name: 'Cuba', flag: '🇨🇺' },
    { id: 'CY', code: '+357', name: 'Cyprus', flag: '🇨🇾' },
    { id: 'CZ', code: '+420', name: 'Czech Republic', flag: '🇨🇿' },
    { id: 'DK', code: '+45', name: 'Denmark', flag: '🇩🇰' },
    { id: 'DJ', code: '+253', name: 'Djibouti', flag: '🇩🇯' },
    { id: 'DM', code: '+1', name: 'Dominica', flag: '🇩🇲' },
    { id: 'DO', code: '+1', name: 'Dominican Republic', flag: '🇩🇴' },
    { id: 'TL', code: '+670', name: 'East Timor', flag: '🇹🇱' },
    { id: 'EC', code: '+593', name: 'Ecuador', flag: '🇪🇨' },
    { id: 'EG', code: '+20', name: 'Egypt', flag: '🇪🇬' },
    { id: 'SV', code: '+503', name: 'El Salvador', flag: '🇸🇻' },
    { id: 'GQ', code: '+240', name: 'Equatorial Guinea', flag: '🇬🇶' },
    { id: 'ER', code: '+291', name: 'Eritrea', flag: '🇪🇷' },
    { id: 'EE', code: '+372', name: 'Estonia', flag: '🇪🇪' },
    { id: 'ET', code: '+251', name: 'Ethiopia', flag: '🇪🇹' },
    { id: 'FJ', code: '+679', name: 'Fiji', flag: '🇫🇯' },
    { id: 'FI', code: '+358', name: 'Finland', flag: '🇫🇮' },
    { id: 'FR', code: '+33', name: 'France', flag: '🇫🇷' },
    { id: 'GA', code: '+241', name: 'Gabon', flag: '🇬🇦' },
    { id: 'GM', code: '+220', name: 'Gambia', flag: '🇬🇲' },
    { id: 'GE', code: '+995', name: 'Georgia', flag: '🇬🇪' },
    { id: 'DE', code: '+49', name: 'Germany', flag: '🇩🇪' },
    { id: 'GH', code: '+233', name: 'Ghana', flag: '🇬🇭' },
    { id: 'GR', code: '+30', name: 'Greece', flag: '🇬🇷' },
    { id: 'GD', code: '+1', name: 'Grenada', flag: '🇬🇩' },
    { id: 'GT', code: '+502', name: 'Guatemala', flag: '🇬🇹' },
    { id: 'GN', code: '+224', name: 'Guinea', flag: '🇬🇳' },
    { id: 'GW', code: '+245', name: 'Guinea-Bissau', flag: '🇬🇼' },
    { id: 'GY', code: '+592', name: 'Guyana', flag: '🇬🇾' },
    { id: 'HT', code: '+509', name: 'Haiti', flag: '🇭🇹' },
    { id: 'HN', code: '+504', name: 'Honduras', flag: '🇭🇳' },
    { id: 'HU', code: '+36', name: 'Hungary', flag: '🇭🇺' },
    { id: 'IS', code: '+354', name: 'Iceland', flag: '🇮🇸' },
    { id: 'IN', code: '+91', name: 'India', flag: '🇮🇳' },
    { id: 'ID', code: '+62', name: 'Indonesia', flag: '🇮🇩' },
    { id: 'IR', code: '+98', name: 'Iran', flag: '🇮🇷' },
    { id: 'IQ', code: '+964', name: 'Iraq', flag: '🇮🇶' },
    { id: 'IE', code: '+353', name: 'Ireland', flag: '🇮🇪' },
    { id: 'IL', code: '+972', name: 'Israel', flag: '🇮🇱' },
    { id: 'IT', code: '+39', name: 'Italy', flag: '🇮🇹' },
    { id: 'JM', code: '+1', name: 'Jamaica', flag: '🇯🇲' },
    { id: 'JP', code: '+81', name: 'Japan', flag: '🇯🇵' },
    { id: 'JO', code: '+962', name: 'Jordan', flag: '🇯🇴' },
    { id: 'KZ', code: '+7', name: 'Kazakhstan', flag: '🇰🇿' },
    { id: 'KE', code: '+254', name: 'Kenya', flag: '🇰🇪' },
    { id: 'KI', code: '+686', name: 'Kiribati', flag: '🇰🇮' },
    { id: 'KP', code: '+850', name: 'North Korea', flag: '🇰🇵' },
    { id: 'KR', code: '+82', name: 'South Korea', flag: '🇰🇷' },
    { id: 'KW', code: '+965', name: 'Kuwait', flag: '🇰🇼' },
    { id: 'KG', code: '+996', name: 'Kyrgyzstan', flag: '🇰🇬' },
    { id: 'LA', code: '+856', name: 'Laos', flag: '🇱🇦' },
    { id: 'LV', code: '+371', name: 'Latvia', flag: '🇱🇻' },
    { id: 'LB', code: '+961', name: 'Lebanon', flag: '🇱🇧' },
    { id: 'LS', code: '+266', name: 'Lesotho', flag: '🇱🇸' },
    { id: 'LR', code: '+231', name: 'Liberia', flag: '🇱🇷' },
    { id: 'LY', code: '+218', name: 'Libya', flag: '🇱🇾' },
    { id: 'LI', code: '+423', name: 'Liechtenstein', flag: '🇱🇮' },
    { id: 'LT', code: '+370', name: 'Lithuania', flag: '🇱🇹' },
    { id: 'LU', code: '+352', name: 'Luxembourg', flag: '🇱🇺' },
    { id: 'MK', code: '+389', name: 'North Macedonia', flag: '🇲🇰' },
    { id: 'MG', code: '+261', name: 'Madagascar', flag: '🇲🇬' },
    { id: 'MW', code: '+265', name: 'Malawi', flag: '🇲🇼' },
    { id: 'MY', code: '+60', name: 'Malaysia', flag: '🇲🇾' },
    { id: 'MV', code: '+960', name: 'Maldives', flag: '🇲🇻' },
    { id: 'ML', code: '+223', name: 'Mali', flag: '🇲🇱' },
    { id: 'MT', code: '+356', name: 'Malta', flag: '🇲🇹' },
    { id: 'MH', code: '+692', name: 'Marshall Islands', flag: '🇲🇭' },
    { id: 'MR', code: '+222', name: 'Mauritania', flag: '🇲🇷' },
    { id: 'MU', code: '+230', name: 'Mauritius', flag: '🇲🇺' },
    { id: 'MX', code: '+52', name: 'Mexico', flag: '🇲🇽' },
    { id: 'FM', code: '+691', name: 'Micronesia', flag: '🇫🇲' },
    { id: 'MD', code: '+373', name: 'Moldova', flag: '🇲🇩' },
    { id: 'MC', code: '+377', name: 'Monaco', flag: '🇲🇨' },
    { id: 'MN', code: '+976', name: 'Mongolia', flag: '🇲🇳' },
    { id: 'ME', code: '+382', name: 'Montenegro', flag: '🇲🇪' },
    { id: 'MA', code: '+212', name: 'Morocco', flag: '🇲🇦' },
    { id: 'MZ', code: '+258', name: 'Mozambique', flag: '🇲🇿' },
    { id: 'MM', code: '+95', name: 'Myanmar', flag: '🇲🇲' },
    { id: 'NA', code: '+264', name: 'Namibia', flag: '🇳🇦' },
    { id: 'NR', code: '+674', name: 'Nauru', flag: '🇳🇷' },
    { id: 'NP', code: '+977', name: 'Nepal', flag: '🇳🇵' },
    { id: 'NL', code: '+31', name: 'Netherlands', flag: '🇳🇱' },
    { id: 'NZ', code: '+64', name: 'New Zealand', flag: '🇳🇿' },
    { id: 'NI', code: '+505', name: 'Nicaragua', flag: '🇳🇮' },
    { id: 'NE', code: '+227', name: 'Niger', flag: '🇳🇪' },
    { id: 'NG', code: '+234', name: 'Nigeria', flag: '🇳🇬' },
    { id: 'NO', code: '+47', name: 'Norway', flag: '🇳🇴' },
    { id: 'OM', code: '+968', name: 'Oman', flag: '🇴🇲' },
    { id: 'PK', code: '+92', name: 'Pakistan', flag: '🇵🇰' },
    { id: 'PW', code: '+680', name: 'Palau', flag: '🇵🇼' },
    { id: 'PS', code: '+970', name: 'Palestine', flag: '🇵🇸' },
    { id: 'PA', code: '+507', name: 'Panama', flag: '🇵🇦' },
    { id: 'PG', code: '+675', name: 'Papua New Guinea', flag: '🇵🇬' },
    { id: 'PY', code: '+595', name: 'Paraguay', flag: '🇵🇾' },
    { id: 'PE', code: '+51', name: 'Peru', flag: '🇵🇪' },
    { id: 'PH', code: '+63', name: 'Philippines', flag: '🇵🇭' },
    { id: 'PL', code: '+48', name: 'Poland', flag: '🇵🇱' },
    { id: 'PT', code: '+351', name: 'Portugal', flag: '🇵🇹' },
    { id: 'QA', code: '+974', name: 'Qatar', flag: '🇶🇦' },
    { id: 'RO', code: '+40', name: 'Romania', flag: '🇷🇴' },
    { id: 'RU', code: '+7', name: 'Russia', flag: '🇷🇺' },
    { id: 'RW', code: '+250', name: 'Rwanda', flag: '🇷🇼' },
    { id: 'KN', code: '+1', name: 'Saint Kitts and Nevis', flag: '🇰🇳' },
    { id: 'LC', code: '+1', name: 'Saint Lucia', flag: '🇱🇨' },
    { id: 'VC', code: '+1', name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
    { id: 'WS', code: '+685', name: 'Samoa', flag: '🇼🇸' },
    { id: 'SM', code: '+378', name: 'San Marino', flag: '🇸🇲' },
    { id: 'ST', code: '+239', name: 'São Tomé and Príncipe', flag: '🇸🇹' },
    { id: 'SA', code: '+966', name: 'Saudi Arabia', flag: '🇸🇦' },
    { id: 'SN', code: '+221', name: 'Senegal', flag: '🇸🇳' },
    { id: 'RS', code: '+381', name: 'Serbia', flag: '🇷🇸' },
    { id: 'SC', code: '+248', name: 'Seychelles', flag: '🇸🇨' },
    { id: 'SL', code: '+232', name: 'Sierra Leone', flag: '🇸🇱' },
    { id: 'SG', code: '+65', name: 'Singapore', flag: '🇸🇬' },
    { id: 'SK', code: '+421', name: 'Slovakia', flag: '🇸🇰' },
    { id: 'SI', code: '+386', name: 'Slovenia', flag: '🇸🇮' },
    { id: 'SB', code: '+677', name: 'Solomon Islands', flag: '🇸🇧' },
    { id: 'SO', code: '+252', name: 'Somalia', flag: '🇸🇴' },
    { id: 'ZA', code: '+27', name: 'South Africa', flag: '🇿🇦' },
    { id: 'SS', code: '+211', name: 'South Sudan', flag: '🇸🇸' },
    { id: 'ES', code: '+34', name: 'Spain', flag: '🇪🇸' },
    { id: 'LK', code: '+94', name: 'Sri Lanka', flag: '🇱🇰' },
    { id: 'SD', code: '+249', name: 'Sudan', flag: '🇸🇩' },
    { id: 'SR', code: '+597', name: 'Suriname', flag: '🇸🇷' },
    { id: 'SZ', code: '+268', name: 'Eswatini', flag: '🇸🇿' },
    { id: 'SE', code: '+46', name: 'Sweden', flag: '🇸🇪' },
    { id: 'CH', code: '+41', name: 'Switzerland', flag: '🇨🇭' },
    { id: 'SY', code: '+963', name: 'Syria', flag: '🇸🇾' },
    { id: 'TW', code: '+886', name: 'Taiwan', flag: '🇹🇼' },
    { id: 'TJ', code: '+992', name: 'Tajikistan', flag: '🇹🇯' },
    { id: 'TZ', code: '+255', name: 'Tanzania', flag: '🇹🇿' },
    { id: 'TH', code: '+66', name: 'Thailand', flag: '🇹🇭' },
    { id: 'TG', code: '+228', name: 'Togo', flag: '🇹🇬' },
    { id: 'TO', code: '+676', name: 'Tonga', flag: '🇹🇴' },
    { id: 'TT', code: '+1', name: 'Trinidad and Tobago', flag: '🇹🇹' },
    { id: 'TN', code: '+216', name: 'Tunisia', flag: '🇹🇳' },
    { id: 'TR', code: '+90', name: 'Turkey', flag: '🇹🇷' },
    { id: 'TM', code: '+993', name: 'Turkmenistan', flag: '🇹🇲' },
    { id: 'TV', code: '+688', name: 'Tuvalu', flag: '🇹🇻' },
    { id: 'UG', code: '+256', name: 'Uganda', flag: '🇺🇬' },
    { id: 'UA', code: '+380', name: 'Ukraine', flag: '🇺🇦' },
    { id: 'AE', code: '+971', name: 'United Arab Emirates', flag: '🇦🇪' },
    { id: 'GB', code: '+44', name: 'United Kingdom', flag: '🇬🇧' },
    { id: 'US', code: '+1', name: 'United States', flag: '🇺🇸' },
    { id: 'UY', code: '+598', name: 'Uruguay', flag: '🇺🇾' },
    { id: 'UZ', code: '+998', name: 'Uzbekistan', flag: '🇺🇿' },
    { id: 'VU', code: '+678', name: 'Vanuatu', flag: '🇻🇺' },
    { id: 'VA', code: '+379', name: 'Vatican City', flag: '🇻🇦' },
    { id: 'VE', code: '+58', name: 'Venezuela', flag: '🇻🇪' },
    { id: 'VN', code: '+84', name: 'Vietnam', flag: '🇻🇳' },
    { id: 'YE', code: '+967', name: 'Yemen', flag: '🇾🇪' },
    { id: 'ZM', code: '+260', name: 'Zambia', flag: '🇿🇲' },
    { id: 'ZW', code: '+263', name: 'Zimbabwe', flag: '🇿🇼' },
];
export const PhoneLoginForm = ({ onSuccess, onError }) => {
    const [selectedCountry, setSelectedCountry] = useState('US');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [verificationId, setVerificationId] = useState(null);
    const [agreeToTerms, setAgreeToTerms] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { startPhoneSignIn, confirmPhoneSignIn } = useAuth();
    const { showNotification } = useNotification();
    // Show error notification when there's an error
    const prevErrorRef = useRef(null);
    useEffect(() => {
        if (error && error !== prevErrorRef.current) {
            prevErrorRef.current = error;
            // Special handling for reCAPTCHA already rendered error
            if (error.includes('reCAPTCHA has already been rendered in this element')) {
                showNotification({
                    message: 'Authentication system issue. Please reload the page and try again.',
                    severity: 'error'
                });
            }
            else {
                showNotification({
                    message: error,
                    severity: 'error'
                });
            }
            // Also call the onError callback if provided
            if (onError) {
                onError(new Error(error));
            }
        }
    }, [error, showNotification, onError]);
    const handleSendCode = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!phoneNumber) {
            setError('Please enter a phone number');
            return;
        }
        if (!agreeToTerms) {
            setError('You must agree to the Terms of Service');
            return;
        }
        try {
            setLoading(true);
            setError(null);
            const country = countries.find(c => c.id === selectedCountry);
            const fullPhoneNumber = `${country === null || country === void 0 ? void 0 : country.code}${phoneNumber.replace(/\D/g, '')}`;
            const id = yield startPhoneSignIn(fullPhoneNumber);
            setVerificationId(id);
        }
        catch (err) {
            setError(err.message || 'Failed to send verification code');
        }
        finally {
            setLoading(false);
        }
    });
    const handleVerifyCode = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!verificationCode || !verificationId) {
            setError('Please enter the verification code');
            return;
        }
        try {
            setLoading(true);
            setError(null);
            yield confirmPhoneSignIn(verificationId, verificationCode);
            if (onSuccess)
                onSuccess();
        }
        catch (err) {
            setError(err.message || 'Failed to verify code');
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h6", component: "h2", gutterBottom: true, children: "Phone Login" }), _jsx("div", { id: "recaptcha-container" }), !verificationId ? (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 4, sm: 3, children: _jsxs(FormControl, { fullWidth: true, margin: "normal", children: [_jsx(InputLabel, { id: "country-code-label", children: "Country" }), _jsx(Select, { labelId: "country-code-label", id: "country-code", value: selectedCountry, label: "Country", onChange: (e) => setSelectedCountry(e.target.value), disabled: loading, renderValue: (value) => {
                                                const country = countries.find(c => c.id === value);
                                                return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center' }, children: [_jsx("span", { style: { marginRight: '8px' }, children: country === null || country === void 0 ? void 0 : country.flag }), _jsx("span", { children: country === null || country === void 0 ? void 0 : country.code })] }));
                                            }, MenuProps: {
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 300,
                                                    },
                                                },
                                            }, children: countries.map((country) => (_jsx(MenuItem, { value: country.id, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center' }, children: [_jsx("span", { style: { marginRight: '8px' }, children: country.flag }), _jsx(ListItemText, { primary: `${country.code} (${country.name})` })] }) }, country.id))) })] }) }), _jsx(Grid, { item: true, xs: 8, sm: 9, children: _jsx(TextField, { margin: "normal", required: true, fullWidth: true, id: "phone", label: "Phone Number", name: "phone", autoComplete: "tel", autoFocus: true, value: phoneNumber, onChange: (e) => setPhoneNumber(e.target.value), disabled: loading, placeholder: "(123) 456-7890", InputProps: {
                                        startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(Phone, {}) })),
                                    } }) })] }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { value: "agreeToTerms", color: "primary", checked: agreeToTerms, onChange: (e) => setAgreeToTerms(e.target.checked), disabled: loading }), label: _jsxs(Typography, { variant: "body2", children: ["I agree to the ", _jsx(Link, { href: "https://www.rentreadybids.com/terms-of-service", target: "_blank", rel: "noopener", underline: "hover", children: "Terms of Service" })] }), sx: { mt: 2 } }), _jsx(Button, { fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, onClick: handleSendCode, disabled: loading, children: loading ? _jsx(CircularProgress, { size: 24 }) : 'Send Verification Code' })] })) : (_jsxs(_Fragment, { children: [_jsx(TextField, { margin: "normal", required: true, fullWidth: true, id: "code", label: "Verification Code", name: "code", autoFocus: true, value: verificationCode, onChange: (e) => setVerificationCode(e.target.value), disabled: loading, InputProps: {
                            startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(Sms, {}) })),
                        } }), _jsx(Button, { fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, onClick: handleVerifyCode, disabled: loading, children: loading ? _jsx(CircularProgress, { size: 24 }) : 'Verify Code' })] }))] }));
};
